import * as React from 'react'

import './styles.scss'

interface IStatisticProps {
  cognitionType: string
  values: number
}

export class StatisticBlock extends React.PureComponent<IStatisticProps> {
  render() {
    const { cognitionType, values } = this.props
    let value
    if (values < 0) {
      value = -values
    }
    return (
      <div className="levels-wrapper">
        <div className="cognition-type">{cognitionType}</div>
        <div className="cognition-level">
          {values > 0 ? `+${values}` : values}
        </div>
        <div className="images-wrapper">
          <div className="images-mask-wrapper-first">
            <div
              className="image-first"
              style={{ width: value ? `${value}%` : 0 }}
            />
          </div>
          <div className="images-mask-wrapper-second">
            <div
              className="image-second"
              style={{ width: values > 0 ? `${values}%` : 0 }}
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/StatisticBlock/index.tsx